import React from 'react';
import { tokenizeLinks } from './linkTokens';

const DEFAULT_LINK_CLASS = 'text-blue-600 underline hover:text-blue-800';

/**
 * テキスト内の Markdownリンク `[テキスト](href)` と生URLを検出してリンク化する関数
 */
export const linkifyText = (
  text: string,
  className: string = DEFAULT_LINK_CLASS
): React.ReactNode[] => {
  return tokenizeLinks(text).map((token, index) => {
    if (token.type === 'link') {
      return React.createElement(
        'a',
        {
          key: index,
          href: token.href,
          target: '_blank',
          rel: 'noopener noreferrer',
          className,
        },
        token.text
      );
    }
    // リンクでない部分はそのままテキストとして表示（コンテナ側の whitespace-pre-wrap で改行を保持）
    return token.value;
  });
};
